import React from 'react';
import { Router } from 'react-router';
import { RACThemeProvider, makeStyles } from '@rentacenter/racstrap';
import clsx from 'clsx';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const History = require('history');
import { ErrorBoundary } from '../components/ErrorBoundary/ErrorBoundary';
import { InContainerAuthProvider } from '../context/auth/InContainerAuthProvider';
import { StandaloneAuthProvider } from '../context/auth/StandaloneAuthProvider';
import { AuthGuard } from '../components/AuthGuard/AuthGuard';
import { BrowserRouter } from 'react-router-dom';
import { Routes } from './Routes';
interface Props {
  history: typeof History;
}

export const appTestId = 'appTestId';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    height: '100vh',
    backgroundColor: '#ECF0F3',
  },
}));

export const App = ({ history }: Props) => {
  const { isRenderedByContainer } = window;
  const classes = useStyles();

  return (
    <div data-testid={appTestId}>
      <RACThemeProvider>
        <div className={clsx(classes.container)}>
          <ErrorBoundary>
            <Router history={history}>
              {isRenderedByContainer ? (
                <InContainerAuthProvider>
                  <AuthGuard />
                </InContainerAuthProvider>
              ) : (
                <StandaloneAuthProvider>
                  <AuthGuard />
                </StandaloneAuthProvider>
              )}
            </Router>
            <BrowserRouter>
              <Routes />
            </BrowserRouter>
          </ErrorBoundary>
        </div>
      </RACThemeProvider>
    </div>
  );
};
